import * as o from "react";
import { cssValue as s } from "./helpers/unitConverter.es.js";
import { createAnimation as h } from "./helpers/animation.es.js";
var a = function() {
  return a = Object.assign || function(e) {
    for (var n, i = 1, r = arguments.length; i < r; i++) {
      n = arguments[i];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, a.apply(this, arguments);
}, _ = function(e, n) {
  var i = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (i[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var t = 0, r = Object.getOwnPropertySymbols(e); t < r.length; t++)
      n.indexOf(r[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[t]) && (i[r[t]] = e[r[t]]);
  return i;
}, j = h("PulseLoader", "0% {transform: scale(1); opacity: 1} 45% {transform: scale(0.1); opacity: 0.7} 80% {transform: scale(1); opacity: 1}", "pulse");
function E(e) {
  var n = e.loading, i = n === void 0 ? !0 : n, r = e.color, t = r === void 0 ? "#000000" : r, c = e.speedMultiplier, d = c === void 0 ? 1 : c, p = e.cssOverride, y = p === void 0 ? {} : p, u = e.size, f = u === void 0 ? 15 : u, m = e.margin, g = m === void 0 ? 2 : m, v = _(e, ["loading", "color", "speedMultiplier", "cssOverride", "size", "margin"]), b = a({ display: "inherit" }, y), l = function(O) {
    return {
      backgroundColor: t,
      width: s(f),
      height: s(f),
      margin: s(g),
      borderRadius: "100%",
      display: "inline-block",
      animation: "".concat(j, " ").concat(0.75 / d, "s ").concat(O * 0.12 / d, "s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08)"),
      animationFillMode: "both"
    };
  };
  return i ? o.createElement(
    "span",
    a({ style: b }, v),
    o.createElement("span", { style: l(1) }),
    o.createElement("span", { style: l(2) }),
    o.createElement("span", { style: l(3) })
  ) : null;
}
export {
  E as default
};
//# sourceMappingURL=PulseLoader.es.js.map
